const PUBLIC_ASSET_FOLDERS = '(?:imagen|imagenalt|slideimagen|bgimagen|web)';

/**
 * CMS records historically contain absolute URLs to the old host. Those
 * files are now shipped by Next from /public, so keep the data local and
 * avoid depending on the legacy host at runtime.
 */
export const localizeAssetUrl = (value) => {
  if (typeof value !== 'string' || !value) return value || '';

  const absoluteAsset = value.match(
    new RegExp(`^(?:https?:)?//(?:www\\.)?clubsurfeduca\\.com/(assets/${PUBLIC_ASSET_FOLDERS}/.+)$`, 'i'),
  );
  if (absoluteAsset) return `/${absoluteAsset[1]}`;

  const relativeAsset = value.match(new RegExp(`^/?(assets/${PUBLIC_ASSET_FOLDERS}/.+)$`, 'i'));
  return relativeAsset ? `/${relativeAsset[1]}` : value;
};

export const localizeAsset = (asset) => {
  if (!asset) return { src: '' };
  return { ...asset, src: localizeAssetUrl(asset.src) };
};

